import { Building } from '../interfaces/api/building';
import axios from 'axios';

export interface BuildingFilterParameters {
	organization?: string;
	type_status?: 'Online' | 'Offline';
	search?: string;
	ordering?: string;
	fields?: string;
}

function queryBuilderBuilding(parameters: BuildingFilterParameters): URLSearchParams {
	const queryParameters = new URLSearchParams();
	if (parameters.organization) {
		queryParameters.append('organization', parameters.organization);
	}
	if (parameters.type_status) {
		queryParameters.append('type_status', parameters.type_status);
	}
	if (parameters.search) {
		queryParameters.append('search', parameters.search);
	}
	if (parameters.ordering) {
		queryParameters.append('ordering', parameters.ordering);
	}
	if (parameters.fields) {
		queryParameters.append('fields', parameters.fields);
	}
	return queryParameters;
}

export async function getBuildings(
	parameters: BuildingFilterParameters,
	signal?: AbortSignal
): Promise<Building[]> {
	try {
		const queryParameters = queryBuilderBuilding(parameters);
		const response = await axios.get<Building[]>('api/buildings/', {
			params: queryParameters,
			signal,
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response?.data;
		}
		throw error;
	}
}
